// extracted by mini-css-extract-plugin
export default {"modal":"AlertCenterModal_modal__PRkdq"};